import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { COLOR_ERROR_SOFT } from "../../../../style/antdTheme.js";
import { __ } from "../../../../utils/i18n.js";
import { InfoCard } from "../infoCard.js";
const CancellationLossList = ({ isRcb })=>{
    const lossItems = [];
    if (isRcb) {
        lossItems.push({
            key: "gdpr",
            lead: __("Your GDPR compliance can drift."),
            rest: __("When regulators update their guidance, your banner won't follow along.")
        });
    }
    lossItems.push({
        key: "updates",
        lead: __("Plugin updates stop arriving."),
        rest: __("Security patches and WordPress compatibility fixes won't reach your website.")
    }, {
        key: "support",
        lead: __("Premium support ends."),
        rest: __("No human responses after your subscription ends.")
    }, {
        key: "price",
        lead: __("Your locked-in price is gone."),
        rest: __("A future re-subscription is at our then-current rate. Promotional pricing isn't guaranteed.")
    }, {
        key: "plan",
        lead: __("Plan changes get frozen."),
        rest: __("You can't upgrade or downgrade once a cancellation is on file (and the cancellation itself can't be withdrawn either).")
    });
    return /*#__PURE__*/ _jsx(InfoCard, {
        variant: "soft-trust",
        leftBorderColor: COLOR_ERROR_SOFT,
        icon: /*#__PURE__*/ _jsx(ExclamationCircleFilled, {
            style: {
                color: COLOR_ERROR_SOFT,
                fontSize: 18
            }
        }),
        heading: __("What you'll lose by cancelling"),
        children: /*#__PURE__*/ _jsx("ul", {
            className: "rc-account-v2-cancellation-loss-list",
            children: lossItems.map((item)=>/*#__PURE__*/ _jsxs("li", {
                    className: "rc-account-v2-cancellation-loss-list__item",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "rc-cancel-loss-lead",
                            children: item.lead
                        }),
                        " ",
                        item.rest
                    ]
                }, item.key))
        })
    });
};
export { CancellationLossList };
